"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowItem = void 0;
const react_1 = require("react");
const Workflow_context_1 = require("../Workflow.context");
// get WorkflowContextItem
function useWorkflowItem(options, params) {
    const { find, findAsync } = (0, Workflow_context_1.useWorkflowContext)();
    const item = (0, react_1.useMemo)(() => {
        return options && find(options);
    }, [options, find]);
    // fetch workflow if not yet cached
    (0, react_1.useEffect)(() => {
        options && findAsync(options, params);
    }, [params, options, findAsync]);
    return item;
}
exports.useWorkflowItem = useWorkflowItem;
//# sourceMappingURL=useWorkflowItem.js.map